/**
 * External dependencies.
 */
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { Trans } from "@lingui/macro";
import classNames from "classnames";

/**
 * Internal dependencies.
 */
// import * as fbq from "../../lib/fpixel";
import ProductSlider from "components/product-slider/product-slider";
import Reviews from "components/reviews/reviews";
import IconOnline2 from "../../assets/images/svg/icon-online2.svg";
import LinkWithOptions from "components/link/link-with-options";
import { capitalize } from "utils";

interface ThemeTopProp {
  app?: boolean;
  data: any;
}

const ThemeTop: React.FC<ThemeTopProp> = ({ data, app }) => {
  const { DetailsList, BuyButton, DemoButton } = data;
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const router = useRouter();

  const handleClick = (index: number, title?: string) => {
    setActiveIndex(index);
    if (!title) {
      return;
    }
    if (title === "Default") {
      if (router.asPath.includes("#")) {
        router.push(router.asPath.split("#")[0]);
      }
    } else {
      if (router.asPath.includes("#")) {
        router.push(router.asPath.split("#")[0] + "#" + title.toLowerCase());
      } else {
        router.push(router.asPath + "#" + title.toLowerCase());
      }
    }
  };

  const handleBuyButton = (e: any) => {
    e.preventDefault();
    const href = e.target.getAttribute("href");
    // fbq.sendBeacon("InitiateCheckout", {
    //   content_ids: [data.Title],
    // });
    router.push(href);
  };

  const handleDemoButton = (e: any) => {
    e.preventDefault();
    const href = e.target.getAttribute("href");
    // fbq.sendBeacon("AddToCard", {
    //   value: data.Price?.match(/\d+/) ? data.Price.match(/\d+/)[0] : 0,
    //   currency: "USD",
    //   content_type: "product",
    //   content_ids: data.Title,
    // });
    router.push(href);
  };

  useEffect(() => {
    if (router.asPath.includes("#")) {
      const hash = router.asPath.split("#")[1];

      const index = data.Variants.findIndex(
        (item: any) => item.Title === capitalize(hash)
      );
      if (index !== -1) {
        setActiveIndex(index);
      }
    } else {
      setActiveIndex(0);
    }
  }, []);

  return (
    <div className="theme-top">
      <div className="container">
        <div className="theme-top__inner">
          <div className="theme-top__slider">
            {data.Variants &&
              activeIndex !== null &&
              data?.Variants[activeIndex]?.Images && (
                <ProductSlider
                  data={data.Variants[activeIndex].Images.data}
                  activeIndex={activeIndex}
                />
              )}
          </div>
          <div className="theme-top__details">
            <div className="theme-top__details-inner">
              <div className="theme-top__row">
                <Reviews count={data.Count} score={data.Review} />
                {app && (
                  <div className="theme-top__details-top">
                    <IconOnline2 />
                  </div>
                )}
              </div>
              <h3>{data.Title}</h3>
              <p>{data.Content}</p>
              <h6>{data.Price}</h6>
              <div className="theme-top__variants">
                {data.Variants?.map((item: any, index: number) => (
                  <button
                    key={index}
                    className={classNames("theme-top__variant", {
                      "is-active": activeIndex === index,
                    })}
                    onClick={() =>
                      handleClick(
                        index,
                        data.Variants ? data.Variants[index].Title : null
                      )
                    }
                  >
                    <span
                      className="variant-color"
                      style={{
                        backgroundColor: item.ColorHexCode,
                        color: item.ColorHexCode,
                      }}
                    ></span>
                    <span className="variant-title">{item.Title}</span>
                  </button>
                ))}
              </div>
              {BuyButton && (
                <LinkWithOptions
                  onClick={handleBuyButton}
                  data={BuyButton}
                  className="btn btn--fullwidth btn--fill"
                />
              )}

              {DemoButton && (
                <LinkWithOptions
                  onClick={handleDemoButton}
                  data={DemoButton}
                  className="btn btn--fullwidth"
                />
              )}

              {DetailsList && (
                <div className="theme-top__details-list">
                  <small>
                    <Trans>Great for</Trans>
                  </small>
                  <ul>
                    {DetailsList.map((item: any, index: number) => (
                      <li key={index}>{item.Text}</li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="theme-top__links-title">
                <Trans>Helpful links</Trans>
              </div>
              <div className="theme-top__links">
                {data.HelpfulLinks.map((item: any, index: number) => (
                  <LinkWithOptions data={item} key={index} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemeTop;
